import { Facebook, Instagram } from '@mui/icons-material'
import { Box, Grid, Link, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ContactUs from '../contactUs/contactUs'

// TikTok Icon Component
const TikTokIcon = ({ style }) => (
    <svg
        viewBox="0 0 24 24"
        style={{ width: 24, height: 24, ...style }}
        fill="currentColor"
    >
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
)

function Footer() {
    let theme = useTheme()
    const { t } = useTranslation()
    return (
        <Box sx={{
            minHeight: '35vh',
            backgroundColor: theme.palette.primary.main,
            overflow: 'hidden',
            p: 3
        }}>
            <Grid container>
                <Grid md={4} xs={12} p={3} order={{ md: 1, xs: 2 }} >
                    <Box display={'flex'} flexDirection='column' alignItems={'center'} justifyContent='center'>
                        <Box m={0}>
                            <img src="/dark-circular-logo.png" alt='logo' style={{
                                width: '80px',
                                // height: '100px'
                            }}>
                            </img>
                        </Box>
                        <Typography variant='h4' color='white'>Astegne</Typography>
                        {/* <Box> */}
                        <Stack mt={2} rowGap={2} direction='column' height={'100%'} justifyContent='center' alignItems='center'>
                            <Stack direction='row' gap={2} >
                                <Link target={'_blank'} href="https://www.instagram.com/astegneapp/?igshid=MzRlODBiNWFlZA==" underline="none">
                                    <Instagram style={{ color: 'white' }}></Instagram>
                                </Link>
                                <Link target={'_blank'} href="https://www.facebook.com/profile.php?id=100092570389153&mibextid=LQQJ4d" underline="none">
                                    <Facebook style={{ color: 'white' }}></Facebook>
                                </Link>
                                <Link target={'_blank'} href="https://www.tiktok.com/@astegne" underline="none">
                                    <TikTokIcon style={{ color: 'white' }} />
                                </Link>
                            </Stack>
                            <Typography textAlign={'center'} color='white'>© {new Date().getFullYear()} Astegne. {t('footer.allRightsReserved')}. {t('common.addisAbabaEthiopia')}. </Typography>
                        </Stack>
                        {/* </Box> */}

                    </Box>

                </Grid>
                <Grid md={8} xs={12} display='flex' order={{ md: 2, xs: 1 }} alignItems={'center'} justifyContent='center'>
                    <Stack>

                        <Typography fontSize={25} color='white' textAlign={'center'}>{t('footer.contactUs')}</Typography>
                        <ContactUs></ContactUs>
                    </Stack>
                </Grid>
            </Grid>

        </Box>
    )
}

export default Footer